import { Singleton } from 'typescript-ioc'
import { AbstractEntityService } from '@halo/services/abstract-entity.service'
import aqe from '@pushly/aqe'
import { IPageAnalysisConfig, IPageAnalysisField } from '@pushly/aqe/lib/interfaces'

@Singleton
export class PageAnalysisFieldsService extends AbstractEntityService<IPageAnalysisField> {
    public async fetchById(pageAnalysisConfigId: number, pageAnalysisFieldId: number) {
        return this.execFetchOne(
            `${aqe.defaults.publicApiDomain}/v3/page-analysis-configs/${pageAnalysisConfigId}/fields/${pageAnalysisFieldId}`,
        )
    }

    public async create(pageAnalysisConfigId: number, createDto: Partial<IPageAnalysisConfig>) {
        return this.execCreate(
            `${aqe.defaults.publicApiDomain}/v3/page-analysis-configs/${pageAnalysisConfigId}/fields`,
            createDto,
        )
    }

    public async patch(
        pageAnalysisConfigId: number,
        pageAnalysisFieldId: number,
        patchDto: Partial<IPageAnalysisConfig>,
    ) {
        return this.execPatch(
            `${aqe.defaults.publicApiDomain}/v3/page-analysis-configs/${pageAnalysisConfigId}/fields/${pageAnalysisFieldId}`,
            patchDto,
        )
    }

    public async delete(pageAnalysisConfigId: number, pageAnalysisFieldId: number) {
        return this.execDelete(
            `${aqe.defaults.publicApiDomain}/v3/page-analysis-configs/${pageAnalysisConfigId}/fields/${pageAnalysisFieldId}`,
        )
    }
}
